import React from "react";

export const InputCheckbox = ({active}) => {
    return (
        <div className={`check${active ? ' active' : ''}`}></div>
    );
}

export default InputCheckbox;